import _ from 'underscore';
import produceClone from 'src/helper/produceClone';
import ProductRepository from "../../repository/ProductRepository";

class ResponseMaker {
    data = [];
    data_to_send = {};

    constructor(data) {
        this.data = data;
        //this.data_to_send = this.defaultValue();
    }

    defaultValue = () => {
        return {
            submittedQuoteList: {},
            submittedQuoteSearchList: {
                count: 0,
                records: []
            },
        };
    }
    process = async () => {
        // Search Quote
        if (this.data.data?.quoteLines?.quoteLineItems) {
            let quoteLineItems = []
            if (_.isArray(this.data.data.quoteLines.quoteLineItems)) {
                this.data.data.quoteLines.quoteLineItems.map((v) => {
                    v.quantity_1 = {};
                    v.quantity_2 = {};
                    v.quantity_3 = {};
                    v.ERPPartNumber = v.partNumber;
                    if (v.quotePriceDetails && v.quotePriceDetails.length > 0) {
                        v.quotePriceDetails.map((q, i) => {
                            let qty = `quantity_${i + 1}`
                            let quantity = {
                                quantity: q.quantity,
                                targetPrice: q.targetPrice,
                                quotedPrice: q.quotedPrice,
                                currency: q.currency,
                                price: q.price,
                                pricingUnit: q.pricingUnit,
                                pricePerPricingUnit: q.pricePerPricingUnit
                            }
                            v[qty] = quantity;
                        })
                    }
                })
                quoteLineItems = produceClone(this.data.data.quoteLines.quoteLineItems);
                // No need for Pricing / Inventory call
                // quoteLineItems = await new ProductRepository().attachProductAndInventoryToAnyObjectNew(quoteLineItems, false, false, false);
                quoteLineItems = await new ProductRepository().getProductInventoryPriceWithCpn(quoteLineItems, false, false);
            }
            this.data_to_send.submittedQuoteSearchList = { count: this.data.data.quoteLines.totalRecords, records: quoteLineItems };
        }
        else
            this.data_to_send.submittedQuoteSearchList = { count: 0, records: [] };

        return this;
    };

    run = () => {
        return this;
    };

    get = () => {
        return {
            data: this.data_to_send
        };
    };
}

export default ResponseMaker;